var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-container",
    class: [_vm.currentClass, {
      'video-container_edge': _vm.isEdge
    }]
  }, [(!_vm.mobile) ? [_c('video', {
    ref: "video_home",
    class: {
      'active': _vm.isActive('home')
    },
    attrs: {
      "muted": "",
      "autoplay": _vm.isActive('home'),
      "data-object-fit": "cover"
    }
  }, [_c('source', {
    attrs: {
      "src": "/f/dist/static/video/home.mp4",
      "type": "video/mp4"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "/f/dist/static/video/home.webm",
      "type": "video/webm"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "/f/dist/static/video/home.ogv",
      "type": "video/ogg"
    }
  })]), _vm._v(" "), _c('video', {
    ref: "video_team",
    class: {
      'active': _vm.isActive('team')
    },
    attrs: {
      "muted": "",
      "autoplay": _vm.currentPage === 'team',
      "data-object-fit": "cover"
    }
  }, [_c('source', {
    attrs: {
      "src": "/f/dist/static/video/team.mp4",
      "type": "video/mp4"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "/f/dist/static/video/team.webm",
      "type": "video/webm"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "/f/dist/static/video/team.ogv",
      "type": "video/ogg"
    }
  })]), _vm._v(" "), _c('video', {
    ref: "video_portfolio",
    class: {
      'active': _vm.isActive('portfolio')
    },
    attrs: {
      "muted": "",
      "autoplay": _vm.currentPage === 'portfolio',
      "data-object-fit": "cover"
    }
  }, [_c('source', {
    attrs: {
      "src": "/f/dist/static/video/portfolio.mp4",
      "type": "video/mp4"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "/f/dist/static/video/portfolio.webm",
      "type": "video/webm"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "/f/dist/static/video/portfolio.ogv",
      "type": "video/ogg"
    }
  })]), _vm._v(" "), _c('video', {
    ref: "video_privateequity",
    class: {
      'active': _vm.isActive('privateequity')
    },
    attrs: {
      "muted": "",
      "autoplay": _vm.currentPage === 'privateequity',
      "data-object-fit": "cover"
    }
  }, [_c('source', {
    attrs: {
      "src": "/f/dist/static/video/privateequity.mp4",
      "type": "video/mp4"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "/f/dist/static/video/privateequity.webm",
      "type": "video/webm"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "/f/dist/static/video/privateequity.ogv",
      "type": "video/ogg"
    }
  })]), _vm._v(" "), _c('video', {
    ref: "video_founders",
    class: {
      'active': _vm.isActive('founders')
    },
    attrs: {
      "muted": "",
      "autoplay": _vm.currentPage === 'founders',
      "data-object-fit": "cover"
    }
  }, [_c('source', {
    attrs: {
      "src": "/f/dist/static/video/founders.mp4",
      "type": "video/mp4"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "/f/dist/static/video/founders.webm",
      "type": "video/webm"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "/f/dist/static/video/founders.ogv",
      "type": "video/ogg"
    }
  })])] : [_c('img', {
    ref: "video_home",
    class: {
      'active': _vm.isActive('home')
    },
    attrs: {
      "src": "/f/dist/static/img/home.jpg",
      "data-object-fit": "cover"
    }
  }), _vm._v(" "), _c('img', {
    ref: "video_team",
    class: {
      'active': _vm.isActive('team')
    },
    attrs: {
      "src": "/f/dist/static/img/team.jpg",
      "data-object-fit": "cover"
    }
  }), _vm._v(" "), _c('img', {
    ref: "video_portfolio",
    class: {
      'active': _vm.isActive('portfolio')
    },
    attrs: {
      "src": "/f/dist/static/img/portfolio.jpg",
      "data-object-fit": "cover"
    }
  }), _vm._v(" "), _c('img', {
    ref: "video_privateequity",
    class: {
      'active': _vm.isActive('privateequity')
    },
    attrs: {
      "src": "/f/dist/static/img/privateequity.jpg",
      "data-object-fit": "cover"
    }
  }), _vm._v(" "), _c('img', {
    ref: "video_founders",
    class: {
      'active': _vm.isActive('founders')
    },
    attrs: {
      "src": "/f/dist/static/img/founders.jpg",
      "data-object-fit": "cover"
    }
  })]], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bcf7e8e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
// module id = 208
// module chunks = 0